import type { AppError, Error } from '@/types'
import { defineStore, storeToRefs } from 'pinia'
import { Ref, ref, computed } from 'vue'
import { track, Events } from '@outputinc/o-analytics'
import { useProductStore } from '@/store/ProductStore'
import { usePlanStore } from '@/store/PlanStore'

export const useErrorsStore = defineStore('ErrorsStore', () => {
  const productStore = useProductStore()
  const planStore = usePlanStore()
  const errors: Ref<Error[]> = ref([])
  const errorType = computed(() => errors.value?.find(err => err.type)?.type)

  const appError = ref<AppError | null>(null)

  const clear = (code = null) => {
    if (!code) {
      errors.value = []
      return
    }

    errors.value = errors.value.filter(err => {
      return err.code !== code
    })
  }

  const push = (error: Error) => {
    const { productId } = storeToRefs(productStore)
    const { selectedPlanCode } = storeToRefs(planStore)

    track(Events.CHECKOUT_SUBSCRIPTION_ERROR, {
      error,
      products: [productId.value],
      planCode: selectedPlanCode.value
    })

    errors.value = [...errors.value, error]
  }

  const find = (field: string) => {
    return errors.value.find(err => err.fields?.includes(field))
  }

  const clearAppError = () => {
    appError.value = null
  }

  const setAppError = (error: AppError) => {
    appError.value = error
  }

  return {
    appError,
    clear,
    clearAppError,
    errorType,
    errors,
    find,
    push,
    setAppError
  }
})
